export const GET_PAGE_OPERATION_LIST_FOR_VALUE_BY_PARAMS = "GET_PAGE_OPERATION_LIST_FOR_VALUE_BY_PARAMS"
export const GET_PAGE_OPERATION_LIST_FOR_VALUE_BY_PARAMS_SUCCESS = "GET_PAGE_OPERATION_LIST_FOR_VALUE_BY_PARAMS_SUCCESS"
export const GET_PAGE_OPERATION_LIST_FOR_VALUE_BY_PARAMS_FAIL = "GET_PAGE_OPERATION_LIST_FOR_VALUE_BY_PARAMS_FAIL"


export const API_ERROR = "API_ERROR"
